(function () {
  var nativeHideTimer = null;
  var nativeDetectGraceUntil = 0;
  var nativeChatWantedVisible = false;

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function isOurWidget(element) {
    return Boolean(element && element.closest && element.closest('[data-wc-contact-chat]'));
  }

  function getRect(element) {
    try {
      return element.getBoundingClientRect();
    } catch (error) {
      return {
        width: 0,
        height: 0,
        bottom: 0,
        right: 0
      };
    }
  }

  function getNativeShopifyChatHosts() {
    var selectors = [
      '#ShopifyChat',
      'shopify-chat',
      '[id*="ShopifyChat"]',
      '[class*="shopify-chat"]',
      'iframe[id*="ShopifyChat"]',
      'iframe[src*="shopifychat"]',
      'iframe[src*="inbox"]',
      'iframe[title*="chat" i]',
      'iframe[title*="message" i]'
    ];

    var hosts = [];

    selectors.forEach(function (selector) {
      qsa(selector).forEach(function (element) {
        if (!isOurWidget(element) && hosts.indexOf(element) === -1) {
          hosts.push(element);
        }
      });
    });

    return hosts;
  }

  function showElement(element) {
    if (!element || element.dataset.wcNativeChatHidden !== 'true') return;

    element.style.opacity = element.dataset.wcNativeChatOldOpacity || '';
    element.style.pointerEvents = element.dataset.wcNativeChatOldPointerEvents || '';
    element.style.visibility = element.dataset.wcNativeChatOldVisibility || '';

    delete element.dataset.wcNativeChatHidden;
    delete element.dataset.wcNativeChatOldOpacity;
    delete element.dataset.wcNativeChatOldPointerEvents;
    delete element.dataset.wcNativeChatOldVisibility;
  }

  function hideElement(element) {
    if (!element || isOurWidget(element)) return;

    if (!element.dataset.wcNativeChatHidden) {
      element.dataset.wcNativeChatHidden = 'true';
      element.dataset.wcNativeChatOldOpacity = element.style.opacity || '';
      element.dataset.wcNativeChatOldPointerEvents = element.style.pointerEvents || '';
      element.dataset.wcNativeChatOldVisibility = element.style.visibility || '';
    }

    element.style.opacity = '0';
    element.style.pointerEvents = 'none';
    element.style.visibility = 'hidden';
  }

  function restoreHiddenNativeElements() {
    qsa('[data-wc-native-chat-hidden="true"]').forEach(showElement);

    getNativeShopifyChatHosts().forEach(function (host) {
      if (host.shadowRoot) {
        qsa('[data-wc-native-chat-hidden="true"]', host.shadowRoot).forEach(showElement);
      }
    });
  }

  function setNativeChatVisible(visible) {
    nativeChatWantedVisible = visible;

    if (visible) {
      document.documentElement.classList.add('wc-shopify-chat-visible');
      restoreHiddenNativeElements();
    } else {
      document.documentElement.classList.remove('wc-shopify-chat-visible');

      /*
        Extra fallback in case the early <head> CSS does not catch
        a Shopify element injected after load.
      */
      getNativeShopifyChatHosts().forEach(function (host) {
        hideElement(host);
      });
    }
  }

  function isNativeChatClassVisible() {
    return document.documentElement.classList.contains('wc-shopify-chat-visible');
  }

  function isNativeChatWindowOpen(element) {
    var rect = getRect(element);

    if (!rect.width || !rect.height) return false;

    /*
      Important:
      Open Shopify Inbox is usually a real panel, not just a tiny launcher.
      The old check used width > 220 OR height > 220, which was too broad.
    */
    var desktopOpen = rect.width >= 300 && rect.height >= 360;
    var mobileOpen = window.innerWidth < 750 && rect.width >= 260 && rect.height >= 360;

    return desktopOpen || mobileOpen;
  }

  function hasOpenNativeChatWindow() {
    var hosts = getNativeShopifyChatHosts();

    for (var i = 0; i < hosts.length; i += 1) {
      if (isNativeChatWindowOpen(hosts[i])) {
        return true;
      }
    }

    return false;
  }

  function hideNativeShopifyLauncher() {
    /*
      After clicking the native launcher we give Shopify a short moment
      to resize from small launcher to open chat panel.
    */
    if (Date.now() < nativeDetectGraceUntil) {
      document.documentElement.classList.add('wc-shopify-chat-visible');
      return;
    }

    /*
      If the actual chat panel is open, keep it visible.
      If it has been closed and turned back into a launcher, hide it.
    */
    if (nativeChatWantedVisible && hasOpenNativeChatWindow()) {
      document.documentElement.classList.add('wc-shopify-chat-visible');
      restoreHiddenNativeElements();
      return;
    }

    setNativeChatVisible(false);
  }

  function forceHideNativeShopifyChat() {
    nativeDetectGraceUntil = 0;
    setNativeChatVisible(false);

    window.setTimeout(function () {
      setNativeChatVisible(false);
    }, 80);

    window.setTimeout(function () {
      setNativeChatVisible(false);
    }, 300);
  }

  function findShopifyChatButton() {
    var hosts = getNativeShopifyChatHosts();

    for (var h = 0; h < hosts.length; h += 1) {
      var host = hosts[h];

      if (host.shadowRoot) {
        var shadowButton =
          qs('button[aria-label*="chat" i]', host.shadowRoot) ||
          qs('button[aria-label*="message" i]', host.shadowRoot) ||
          qs('[role="button"][aria-label*="chat" i]', host.shadowRoot) ||
          qs('[role="button"][aria-label*="message" i]', host.shadowRoot) ||
          qs('button', host.shadowRoot);

        if (shadowButton) return shadowButton;
      }

      if (host.tagName && host.tagName.toLowerCase() !== 'iframe') {
        var hostButton =
          qs('button[aria-label*="chat" i]', host) ||
          qs('button[aria-label*="message" i]', host) ||
          qs('[role="button"][aria-label*="chat" i]', host) ||
          qs('[role="button"][aria-label*="message" i]', host) ||
          qs('button', host);

        if (hostButton) return hostButton;
      }
    }

    var pageButtons = qsa(
      '#ShopifyChat button, shopify-chat button, [id*="ShopifyChat"] button, [class*="shopify-chat"] button, button[aria-label*="chat" i], button[aria-label*="message" i]'
    ).filter(function (button) {
      return !isOurWidget(button);
    });

    return pageButtons[0] || null;
  }

  function openShopifyInbox() {
    var button;

    /*
      Show native Shopify widget only long enough to click it.
    */
    nativeDetectGraceUntil = Date.now() + 2500;
    setNativeChatVisible(true);

    button = findShopifyChatButton();

    if (button) {
      button.click();

      /*
        Keep visible while Shopify transforms launcher into open panel.
        After that, interval will check actual size:
        - big panel = keep visible;
        - closed launcher = hide again.
      */
      nativeDetectGraceUntil = Date.now() + 3000;
      nativeChatWantedVisible = true;

      window.setTimeout(hideNativeShopifyLauncher, 3200);
      return true;
    }

    nativeDetectGraceUntil = 0;
    setNativeChatVisible(false);
    return false;
  }

  function closeWidget(widget) {
    var panel = qs('[data-wc-contact-chat-panel]', widget);
    var toggle = qs('[data-wc-contact-chat-toggle]', widget);

    if (panel) panel.hidden = true;
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function closeAllExcept(current) {
    qsa('[data-wc-contact-chat]').forEach(function (widget) {
      if (widget === current) return;
      closeWidget(widget);
    });
  }

  function initChatChooser(widget) {
    if (!widget || widget.dataset.wcContactChatReady === 'true') return;

    var toggle = qs('[data-wc-contact-chat-toggle]', widget);
    var panel = qs('[data-wc-contact-chat-panel]', widget);
    var shopifyButton = qs('[data-wc-chat-shopify]', widget);

    if (!toggle || !panel) return;

    widget.dataset.wcContactChatReady = 'true';

    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      /*
        If native Shopify chat is visible/open, our round button hides it.
      */
      if (isNativeChatClassVisible()) {
        forceHideNativeShopifyChat();
        closeWidget(widget);
        return;
      }

      var willOpen = panel.hidden;

      closeAllExcept(widget);
      panel.hidden = !willOpen;
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });

    if (shopifyButton) {
      shopifyButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        closeWidget(widget);

        window.setTimeout(function () {
          var opened = openShopifyInbox();

          if (!opened) {
            console.warn('Wedcharm chat: Shopify Inbox launcher was not found. Make sure Shopify Inbox is enabled.');
          }
        }, 180);
      });
    }
  }

  function initAll() {
    qsa('[data-wc-contact-chat]').forEach(initChatChooser);

    window.setTimeout(hideNativeShopifyLauncher, 100);
    window.setTimeout(hideNativeShopifyLauncher, 600);
    window.setTimeout(hideNativeShopifyLauncher, 1400);
    window.setTimeout(hideNativeShopifyLauncher, 2600);
  }

  function scheduleNativeHide() {
    if (nativeHideTimer) {
      window.clearTimeout(nativeHideTimer);
    }

    nativeHideTimer = window.setTimeout(function () {
      hideNativeShopifyLauncher();
    }, 180);
  }

  document.addEventListener('click', function (event) {
    qsa('[data-wc-contact-chat]').forEach(function (widget) {
      if (widget.contains(event.target)) return;
      closeWidget(widget);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    qsa('[data-wc-contact-chat]').forEach(function (widget) {
      closeWidget(widget);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);

  /*
    Shopify Inbox can inject/rescale itself after page load.
  */
  var observer = new MutationObserver(scheduleNativeHide);

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class', 'hidden', 'aria-hidden']
  });

  /*
    This is the important part:
    if user closes native Shopify Chat and it turns back into a launcher,
    the interval sees that the large panel is gone and hides it again.
  */
  window.setInterval(function () {
    hideNativeShopifyLauncher();
  }, 700);
})();